import React, { Component } from 'react';
import { DashboardLayout } from '../../layout';
import connect from 'react-redux/es/connect/connect';
import { createSelector } from 'reselect';
import { itemService, globalService as gs } from '../../../common/services';
import { alertSelectors } from '../../../common/redux/selectors';
import moment from 'moment-timezone';
import Skeleton from '@material-ui/lab/Skeleton';
import Pagination from '@material-ui/lab/Pagination';

class TutorTransaction extends Component {

    constructor(props) {
        super(props);
        this.state = {
            transactions: null,
            pagination: null,
            loading: false,
        };
    }

    componentDidMount() {
        this.loadTransaction();
    }

    loadTransaction = (params = null) => {
        const { dispatch } = this.props;
        this.setState({loading: true});
        itemService.transactions("GET", null, params).then(data => {
            let transactions = data.items;
            let pagination = data.pagination;
            this.setState({transactions, pagination, loading: false});
        })
        .catch(exception => {
            gs.showErrors(exception, dispatch, alertSelectors);
            this.setState({loading: false});
        });
    }

    onChangePage = (event, page) => {
        this.loadTransaction({page: page});
    }

    render() {
        const { transactions, pagination, loading } = this.state;
        return (<DashboardLayout>
            <section className="dashboard">
                <div className="row">
                    <div className="col-md-12 mb-4">
                        <div className="post-box">
                            <h2 className="mb-0 page-title">Transaction History</h2>
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-12">
                        <div className="table-responsive">
                            <table className="table">
                                <thead>
                                    <tr>
                                        <th width="25%">Order ID</th>
                                        <th width="25%">Parent Name</th>
                                        <th width="25%">Amount</th>
                                        <th width="25%">Transaction Date</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {loading ? <>
                                        {[1,2,3].map((item) =>
                                            <tr>
                                                <td colSpan="4">
                                                    <Skeleton width="90%" />
                                                    <Skeleton width="70%" />
                                                    <Skeleton width="60%" />
                                                </td>
                                            </tr>
                                        )}
                                    </> : <>
                                        {transactions && transactions.map(item => 
                                        <tr key={item.created_at}>
                                            <td>{item.transactionID}</td>
                                            <td>{item && item.response_data.source && item.response_data.source.name}</td>
                                            <td>${parseFloat(item.total_amount).toFixed(2)}</td>
                                            <td>{moment(item.created_at * 1000).format('MM/DD/YYYY')}</td>
                                        </tr>)}
                                    </>}
                                    {pagination && pagination.totalCount > 19 && <>
                                        <tr>
                                            <td colSpan="4">
                                                <Pagination count={Math.ceil(parseInt(pagination && pagination.totalCount) / 20)} defaultPage={1} siblingCount={0} size="large" color="primary" onChange={this.onChangePage} />
                                            </td>
                                        </tr>
                                    </>}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>

            </section> 
        </DashboardLayout>);
    }
}

const processSelector = createSelector(
    state => state.process,
    process => process
);
const mapStateToProps = createSelector(
    processSelector,
    (process) => ({
        process
    })
);

export default connect(mapStateToProps)(TutorTransaction);